import React, { Component } from "react";
import { Link } from "react-router-dom";
import RightMenu from "../RightMenu";
import RightIconMenu from "../RightIconMenu";

//import HtmlToReactParser from 'html-to-react';
import "./index.css";
//import CalendarPicker from 'rc-calendar';
export default class View_type_21 extends Component {
	constructor(props) {
		super(props);
		//console.log("Artists");
		//console.log("View_type_21: ", props);
		var data = Array.isArray(props.data) ? props.data[0] : props.data;
		this.state = {
			data: data,
			rightMenu: data.right_menu ? data.right_menu : [],
			rightIconMenu: data.right_icon_menu ? data.right_icon_menu : [],
			title: data.title ? data.title : "",
			tabs: data.tabs ? data.tabs : [],
			calendar: data.calendar ? data.calendar : [],
			content: data.content ? data.content : [],
			read_more: data.read_more ? data.read_more : [],
			list: data.list ? data.list : [],
			text: data.lang ? data.lang : []
		};
		// console.log("dsdssd", this.state.list[0].title.fontColor);
	}

	createMarkup(item) {
		return { __html: item };
	}

	render() {
		//console.log('View_type_21',this.state);
		let font = this.state.data.fontColor;
		var _this = this;
		var var1 = this.state.data.title ? this.state.data.title : "";

		return (
			<div className="vt1">
				<div className="left col-xs-12 col-sm-12 col-md-9 col-lg-9">
					<div className="vt1-title row">
						<div
							className="vt21-title-name"
							dangerouslySetInnerHTML={{ __html: var1 }}
						/>
						<div className="right col-xs-3 col-sm-3 col-md-3 col-lg-3 rightMobile">
							{this.state.rightMenu.length >=1 ? (
								<div className="RightMenu">
									<ul className="right_menu_items rowItems">
										{this.state.rightMenu.map(function(object, i) {
											var var4 = object.url ? object.url : "";
											var var5 = object.name ? object.name : "";
											//console.log("RightMenu", object);
											return (
												<li className="left-menuItem" key={i}>
													<Link className="left-menuUnit" to={"/" + var4}>
														{var5}
													</Link>
												</li>
											);
										})}
									</ul>
								</div>
							) : null}
						</div>
						{/* <div className="vt1-title-tabs col-xs-6 col-sm-6 col-md-6 col-lg-6">
							{this.state.tabs.map(function(object, i) {
								if (object.active === 1) {
									return (
										<div
											className="tab col-xs-6 col-sm-6 col-md-6 col-lg-6"
											key={i}
										>
											<div className="tab-checked">
												<Link to={"/" + object.link}>{object.title}</Link>
											</div>
										</div>
									);
								} else {
									return (
										<div
											className="tab col-xs-6 col-sm-6 col-md-6 col-lg-6"
											key={i}
										>
											<Link to={"/" + object.link}>{object.title}</Link>
										</div>
									);
								}
							})}
						</div> */}
					</div>
					<div className="row">
						{this.state.data.list
							? this.state.data.list.map(function(object, i) {
								if (
									object !== "undefined" &&
									object.hasOwnProperty("img") &&
									!object.hasOwnProperty("text")
								) {
									var color = object.title.backgroundColor;
									var img = object.img;
									var image = object.place_image;
									var thumbnail = (
										<div
											style={{
												flex: 1,
												backgroundColor: color,
												padding: 10,
												color: "white",
												position: "absolute",
												left: 15,
												right: 15
											}}
										>
											{object.title.text}
										</div>
									);
									return (
										<div
											className="col-xs-12 col-sm-12 col-md-12 col-lg-12"
											key={i}
										>
											<div>
												{thumbnail}
												<img src={img} className="list_image" />
											</div>
										</div>
									);
								} else if (
									object !== "undefined" &&
									!object.hasOwnProperty("img")
								) {
									var color = object.title ? object.title.backgroundColor : "";
									var button = null;
									var img = object.img;
									var image = object.place_image;
									var thumbnail = (
										<div
											className="middle-thumbnailholder vt21 place_city"
											style={{
												flex: 1,
												padding: 10,
												color: font
											}}
										>
											<div
												className="vt21-apla"
												style={{
													backgroundColor: typeof object.place_color == "string" ? object.place_color : object.place_color[i]
												}}
											>
											</div>

											<div
												className="vt21-text"
											>
												{object.place_city ? object.place_city : ""}
											</div>

											<img
												className="vt21-image"
												src={image} 
												alt={`${object.place_name} alt`}
											/>


										</div>




									);

									if (typeof object.url !== "undefined") {
										button = (
											<div className="middle-addelem">
												<Link to={object.url} className="more_button" aria-label="read more">
													{" "}
												</Link>
											</div>
										);
									}

									return (

										<div
											className="col-xs-12 col-sm-6 col-md-6 col-lg-6 text-center justify-me"
											key={i}
										>
											<div
												className="middle-postblock"
												style={{ cursor: "pointer", fontWeight: "bold" }}
												onClick={() => (window.location.href = `${object.url}`)}
											>
												{thumbnail}
												<div
													className="vt21 place_name"
													dangerouslySetInnerHTML={_this.createMarkup(
														object.place_name
													)}
												/>
												<p className="vt21 row__title">{object.title}</p>
												<div
													className="vt21 text__content"
													// style={{
													// 	fontWeight: "bold"
													// }}
													dangerouslySetInnerHTML={_this.createMarkup(
														object.description
													)}
												/>
												{button}
											</div>
										</div>

									);
								} else if (object !== "undefined") {
									var color = object.title ? object.title.backgroundColor : "";
									var button = null;
									var img = object.img;
									var thumbnail = (
										<div
											className="middle-thumbnailholder"
											style={{
												flex: 1,
												backgroundColor: color,
												color: "white",
												position: "absolute",
												left: 25,
												right: 25,
												padding: 10
											}}
										>
											{object.title.text}
										</div>
									);
									var img = <img src={img} />;

									if (typeof object.button !== "undefined") {
										button = (
											<div className="middle-addelem">
												<Link to={object.button.link} className="more_button">
													{" "}
												</Link>
											</div>
										);
									}

									return (
										<div
											className="col-xs-6 col-sm-6 col-md-6 col-lg-6 text-center"
											key={i}
										>
											<div className="middle-postblock">
												<div>
													{thumbnail}
													{img}
												</div>
												<div
													dangerouslySetInnerHTML={_this.createMarkup(
														object.text
													)}
												/>
												{button}
											</div>
										</div>
									);
								}
							})
							:
								<div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 text-center justify-me">

									<span>{this.state.text}</span>
								</div>
							}
					</div>
				</div>
				<div className="right col-xs-3 col-sm-3 col-md-3 col-lg-3">
					{/* <div className="vt1-calendar">
						<Link to={this.state.calendar.url}>
							<img className="vt1-calendar-img" src={this.state.calendar.img} />
							{this.state.calendar.text}
						</Link>
					</div> */}
					{/* {console.log(this.state.rightMenu,"this.state.rightMenu")} */}
					{this.state.rightMenu.length >=1 ? (
						<div className="RightMenu">
							<ul className="right_menu_items">
								{this.state.rightMenu.map(function(object, i) {
									var var4 = object.url ? object.url : "";
									var var5 = object.name ? object.name : "";
									//console.log("RightMenu", object);
									return (
										<li className="left-menuItem" key={i}>
											<Link className="left-menuUnit" to={"/" + var4}>
												{var5}
											</Link>
										</li>
									);
								})}
							</ul>
						</div>
					) : null}
					{this.state.rightIconMenu &&
						<RightIconMenu data={this.state.rightIconMenu}/>
					}
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/Components/Elements/View_type_21/index.js